import { Stack, Typography, useTheme } from "@mui/material";
import { useMultivalueProperty } from "../../../context/hooks/useMultivalueProperty";
import { GroupMultivaluedProps } from "../Normal/GroupMultivalued";
import { usePropertyContext } from "../../../context/usePropertyContext";
import { FoodsIconButton, FormUnit } from "@foodpilot/foods";
import { useState } from "react";
import { NestedMultiInner } from "./NestedMultiInner";

export type NestedMultivalueProps = GroupMultivaluedProps & {
    totalScore: number | null;
};

export const NestedMultivalue = (props: NestedMultivalueProps) => {
    const theme = useTheme();
    const { property, dimensionValue, totalScore } = props;
    const { scoreUnit } = usePropertyContext();

    const multivalueHandler = useMultivalueProperty({
        property,
        dimensionValue,
    });

    const existingElements = multivalueHandler.elementsGroup.length;
    const [isOpen, setIsOpen] = useState(existingElements === 0);

    return (
        <Stack
            padding={theme.spacing(2)}
            bgcolor={theme.custom.grey[300]}
            border={`1px solid ${theme.custom.grey[600]}`}
            borderRadius={"8px"}
        >
            <Stack flexDirection={"row"} justifyContent={"space-between"} alignItems={"center"}>
                <Typography variant="big-bold">{property.title}</Typography>
                {existingElements > 0 && (
                    <Stack flexDirection={"row"} gap={theme.spacing(1)}>
                        {totalScore !== null && <FormUnit value={totalScore} unit={scoreUnit} />}
                        <FoodsIconButton
                            size={"s"}
                            icon={isOpen ? "arrowUpShort" : "arrowDownShort"}
                            buttonProps={{
                                onClick: () => {
                                    setIsOpen(!isOpen);
                                },
                            }}
                        />
                    </Stack>
                )}
            </Stack>
            <NestedMultiInner
                {...props}
                multivalueHandler={multivalueHandler}
                existingElements={existingElements}
                isOpen={isOpen}
                setIsOpen={setIsOpen}
            />
        </Stack>
    );
};
